import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography, Table, Button, Space } from "antd";
import { BarChartOutlined, FileExcelOutlined } from "@ant-design/icons";
import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";
import StackBarchart from "./chartJs/StackBarchart";

import * as xlsx from "xlsx";

const { Title } = Typography;

//ปกติ
const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

//ย่อ
const cardStyle2 = {
  height: 200,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

//ขยาย
const cardStyle3 = {
  height: 970,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};
const cardStyle4 = {
  height: 740,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_1 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar7_1_1, _dataBar7_1_1] = useState();
  const [dataBar7_1_2, _dataBar7_1_2] = useState();
  const [dataBar7_1_3, _dataBar7_1_3] = useState();
  const [dataBar7_1_5, _dataBar7_1_5] = useState();
  const [dataBar7_1_9, _dataBar7_1_9] = useState();
  const [dataBar7_1_20, _dataBar7_1_20] = useState();

  const [dataStack7_1_15, _dataStack7_1_15] = useState();
  const [dataStack7_1_16, _dataStack7_1_16] = useState();
  const [dataStack7_1_17, _dataStack7_1_17] = useState();
  const [dataStack7_1_18, _dataStack7_1_18] = useState();

  const [data7_1_15, _data7_1_15] = useState("");
  const [data7_1_16, _data7_1_16] = useState("");

  useEffect(() => {
    Find_barData("bar7_1_3");
    Find_barData("bar7_1_5");
    Find_barData("bar7_1_9");
    Find_barData("bar7_1_20");

    Find_stackData("stack7_1_15");
    Find_stackData("stack7_1_16");
    Find_stackData("stack7_1_17");
    Find_stackData("stack7_1_18");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db7_1", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = i.name + 543;

            if (order == "bar7_1_3") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other
              });
            } else if (order == "bar7_1_5") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other
              });
            } else if (order == "bar7_1_9") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_1_20") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar7_1_3") {
          _dataBar7_1_3(Tb1);
        } else if (order == "bar7_1_5") {
          _dataBar7_1_5(Tb1);
        } else if (order == "bar7_1_9") {
          _dataBar7_1_9(Tb1);
        } else if (order == "bar7_1_20") {
          _dataBar7_1_20(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_stackData = order => {
    axios
      .post(xURL + "db_stackchart_db7_1", {
        order: order
      })
      .then(result => {
        let Tb1 = [],
          Tb2 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = parseInt(i.name) + 543;

            if (order == "stack7_1_15") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other,
                total: i.total
              });

              Tb2.push({
                c1: zyear,
                c2: i.been,
                c3: i.hiv,
                c4: i.other,
                c5: i.total
              });
            } else if (order == "stack7_1_16") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other,
                total: i.total
              });

              Tb2.push({
                c1: zyear,
                c2: i.been + " %",
                c3: i.hiv + " %",
                c4: i.other + " %",
                c5: i.total + " %"
              });
            } else if (order == "stack7_1_17") {
              Tb1.push({
                name: zyear,
                local: i.local,
                nolocal: i.nolocal,
                total: i.total
              });
            } else if (order == "stack7_1_18") {
              Tb1.push({
                name: zyear,
                local: i.local,
                nolocal: i.nolocal,
                total: i.total
              });
            }
          });
        }

        if (order == "stack7_1_15") {
          _dataStack7_1_15(Tb1);
          _data7_1_15(Tb2);
        } else if (order == "stack7_1_16") {
          _dataStack7_1_16(Tb1);
          _data7_1_16(Tb2);
        } else if (order == "stack7_1_17") {
          _dataStack7_1_17(Tb1);
        } else if (order == "stack7_1_18") {
          _dataStack7_1_18(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const columns7_1_7 = [
    {
      title: "ร้อยละของตัวชี้วัดที่ผ่านเกณฑ์ ประเมินคุณภาพหลักสูตร",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2565",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "2566",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "2567",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    }
  ];

  const data7_1_7 = [
    {
      key: "1",
      c1: "ป.โท",
      c2: "100%",
      c3: "100%",
      c4: "100%"
    },
    {
      key: "2",
      c1: "ป.เอก",
      c2: "100%",
      c3: "100%",
      c4: "100%"
    },
    {
      key: "3",
      c1: "เกณฑ์ประเมิน",
      c2: "100%",
      c3: "100%",
      c4: "100%"
    }
  ];

  const dataEx7_1_7 = [
    {
      c1: "ป.โท",
      c2: "100%",
      c3: "100%",
      c4: "100%"
    },
    {
      c1: "ป.เอก",
      c2: "100%",
      c3: "100%",
      c4: "100%"
    },
    {
      c1: "เกณฑ์ประเมิน",
      c2: "100%",
      c3: "100%",
      c4: "100%"
    }
  ];

  const highlightRows = ["Total", "91"];

  const columns7_1_13 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    },
    {
      title: "",
      dataIndex: "c2",
      key: "c2",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    }
  ];

  const data7_1_13 = [
    {
      key: "1",
      c1: "BEEN",
      c2: "64"
    },
    {
      key: "2",
      c1: "HIV",
      c2: "7"
    },
    {
      key: "3",
      c1: "Other",
      c2: "20"
    },
    {
      key: "4",
      c1: "Total",
      c2: "91"
    }
  ];

  const dataEx7_1_13 = [
    {
      c1: "BEEN",
      c2: "64"
    },
    {
      c1: "HIV",
      c2: "7"
    },
    {
      c1: "Other",
      c2: "20"
    },
    {
      c1: "Total",
      c2: "91"
    }
  ];

  const columns7_1_14 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "64",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "65",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "66",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "67",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "68",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    }
  ];

  const data7_1_14 = [
    {
      key: "1",
      c1: "ข้อเสนอโครงการวิจัยต่างประเทศ",
      c2: "41",
      c3: "39",
      c4: "48",
      c5: "21",
      c6: "11"
    }
  ];

  const dataEx7_1_14 = [
    {
      c1: "ข้อเสนอโครงการวิจัยต่างประเทศ",
      c2: "41",
      c3: "39",
      c4: "48",
      c5: "21",
      c6: "11"
    }
  ];

  const columns7_1_15 = [
    {
      title: "ปีงบประมาณ",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "BEEN",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "HIV",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "Other",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "รวม",
      dataIndex: "c5",
      key: "c5",
      align: "center",
      onCell: () => ({
        style: {
          backgroundColor: "#fff7e6",
          fontWeight: "bold"
        }
      })
    }
  ];

  const columns7_1_16 = [
    {
      title: "ปีงบประมาณ",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "BEEN",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "HIV",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "Other",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "รวม",
      dataIndex: "c5",
      key: "c5",
      align: "center",
      onCell: () => ({
        style: {
          backgroundColor: "#fff7e6",
          fontWeight: "bold"
        }
      })
    }
  ];

  const columns7_1_19 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "68",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_1_19 = [
    {
      key: "1",
      c1: "งบประมาณแผ่นดิน",
      c2: "56,097,600"
    },
    {
      key: "2",
      c1: "งบประมาณทุนวิจัย",
      c2: "111,067,506.47"
    },
    {
      key: "3",
      c1: "อัตราส่วน",
      c2: "1.98"
    }
  ];

  const dataEx7_1_19 = [
    {
      c1: "งบประมาณแผ่นดิน",
      c2: "56,097,600"
    },
    {
      c1: "งบประมาณทุนวิจัย",
      c2: "111,067,506.47"
    },
    {
      c1: "อัตราส่วน",
      c2: "1.98"
    }
  ];

  const columns7_1_21 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_1_21 = [
    {
      key: "1",
      c1: "ผลงานวิจัยตีพิมพ์ (เรื่อง)",
      c2: "148"
    },
    {
      key: "2",
      c1: "งบประมาณแผ่นดิน (ล้านบาท)",
      c2: "56.098"
    },
    {
      key: "3",
      c1: "อัตราส่วน (เรื่อง/ล้านบาท)",
      c2: "2.64"
    }
  ];

  const dataEx7_1_21 = [
    {
      c1: "ผลงานวิจัยตีพิมพ์ (เรื่อง)",
      c2: "148"
    },
    {
      c1: "งบประมาณแผ่นดิน (ล้านบาท)",
      c2: "56.098"
    },
    {
      c1: "อัตราส่วน (เรื่อง/ล้านบาท)",
      c2: "2.64"
    }
  ];

  const columns7_1_27 = [
    {
      title: "",
      dataIndex: "c1",
      key: "c1"
      // align: "center"
    },
    {
      title: "2564",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "2565",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "2566",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "2567",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    }
  ];

  const data7_1_27 = [
    {
      key: "1",
      c1:
        "1.จำนวนรายงานการหยุดชะงักของโครงการเนื่องจากภัยภิบัติหรือภาวะฉุกเฉิน",
      c2: "3",
      c3: "1",
      c4: "0",
      c5: "0",
      c6: "ไม่พบการรายงาน"
    },
    {
      key: "2",
      c1: "2.จำนวนรายงานการเกิดอุบัติภัยร้ายแรงในสถานที่ทำงาน",
      c2: "2",
      c3: "1",
      c4: "1",
      c5: "0",
      c6: "0"
    },
    {
      key: "3",
      c1: "3.จำนวนรายงานการติดเชื้อก่อโรคร้ายแรงจากสถานที่ทำงาน",
      c2: "ไม่พบการรายงาน",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      key: "4",
      c1: "4.จำนวนรายงานเกิดอาการไม่พึงประสงค์จากการใช้ยาในโครงการวิจัย",
      c2: "16",
      c3: "55",
      c4: "52",
      c5: "",
      c6: "74"
    },
    {
      key: "5",
      c1: "5.ร้อยละของคนที่ตกค้างบนอาคาร ในการซ้อมอัคคีภัย",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      key: "6",
      c1: "6.จำนวนครั้งที่ระบบไฟฟ้าสำรองของ freezer farm ไม่ทำงาน",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "1"
    },
    {
      key: "7",
      c1:
        "7.จำนวนรายงานความเสียหายของ human specimen ที่เก็บในตู้ควบคุมอุณหภูมิ",
      c2: "0",
      c3: "0",
      c4: "1",
      c5: "0",
      c6: "0"
    },
    {
      key: "8",
      c1:
        "8.จำนวนรายงานปัญหาของระบบ Remote Access เมื่อต้องปฏิบัติงานจากทางไกล (เหตุการณ์)",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      key: "9",
      c1: "9. CMU Vulnerability Tracking System (Critical)",
      c2: "ไม่พบการรายงาน",
      c3: "ไม่พบการรายงาน",
      c4: "447",
      c5: "0",
      c6: "0"
    },
    {
      key: "10",
      c1: "10.จำนวนรายงานการเจาะระบบของสถาบันฯ โดยผู้ไม่หวังดี (เหตุการณ์)",
      c2: "0",
      c3: "1",
      c4: "1",
      c5: "2",
      c6: "1"
    },
    {
      key: "11",
      c1: "11.ร้อยละของข้อมูลที่สามารถกู้คืนจากความเสียหาย (%)",
      c2: "100%",
      c3: "100%",
      c4: "100%",
      c5: "100%",
      c6: "100%"
    }
  ];

  const dataEx7_1_27 = [
    {
      c1:
        "1.จำนวนรายงานการหยุดชะงักของโครงการเนื่องจากภัยภิบัติหรือภาวะฉุกเฉิน",
      c2: "3",
      c3: "1",
      c4: "0",
      c5: "0",
      c6: "ไม่พบการรายงาน"
    },
    {
      c1: "2.จำนวนรายงานการเกิดอุบัติภัยร้ายแรงในสถานที่ทำงาน",
      c2: "2",
      c3: "1",
      c4: "1",
      c5: "0",
      c6: "0"
    },
    {
      c1: "3.จำนวนรายงานการติดเชื้อก่อโรคร้ายแรงจากสถานที่ทำงาน",
      c2: "ไม่พบการรายงาน",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      c1: "4.จำนวนรายงานเกิดอาการไม่พึงประสงค์จากการใช้ยาในโครงการวิจัย",
      c2: "16",
      c3: "55",
      c4: "52",
      c5: "",
      c6: "74"
    },
    {
      c1: "5.ร้อยละของคนที่ตกค้างบนอาคาร ในการซ้อมอัคคีภัย",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      c1: "6.จำนวนครั้งที่ระบบไฟฟ้าสำรองของ freezer farm ไม่ทำงาน",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "1"
    },
    {
      c1:
        "7.จำนวนรายงานความเสียหายของ human specimen ที่เก็บในตู้ควบคุมอุณหภูมิ",
      c2: "0",
      c3: "0",
      c4: "1",
      c5: "0",
      c6: "0"
    },
    {
      c1:
        "8.จำนวนรายงานปัญหาของระบบ Remote Access เมื่อต้องปฏิบัติงานจากทางไกล (เหตุการณ์)",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      c1: "9. CMU Vulnerability Tracking System (Critical)",
      c2: "ไม่พบการรายงาน",
      c3: "ไม่พบการรายงาน",
      c4: "447",
      c5: "0",
      c6: "0"
    },
    {
      c1: "10.จำนวนรายงานการเจาะระบบของสถาบันฯ โดยผู้ไม่หวังดี (เหตุการณ์)",
      c2: "0",
      c3: "1",
      c4: "1",
      c5: "2",
      c6: "1"
    },
    {
      c1: "11.ร้อยละของข้อมูลที่สามารถกู้คืนจากความเสียหาย (%)",
      c2: "100%",
      c3: "100%",
      c4: "100%",
      c5: "100%",
      c6: "100%"
    }
  ];

  const columns7_1_28 = [
    {
      title: "ผลิตภัณฑ์",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, row, index) => {
        const obj = {
          children: (
            <b>
              {text}
            </b>
          ), // ทำตัวหนา
          props: {}
        };

        // กำหนด rowspan ตามกลุ่ม
        if (index === 0) obj.props.rowSpan = 7;
        else if (index === 7)
          // งานวิจัย
          obj.props.rowSpan = 4;
        else if (index === 11)
          // หลักสูตร
          obj.props.rowSpan = 3; // บริการวิชาการ
        else obj.props.rowSpan = 0; // ซ่อน cell ที่เหลือ

        return obj;
      }
    },
    {
      title: "ผลลัพธ์",
      dataIndex: "c2",
      key: "c2",
      align: "center",
      render: text =>
        <div style={{ textAlign: "left" }}>
          {text}
        </div>
    },
    {
      title: "2564",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "2565",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "2566",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "2567",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c7",
      key: "c7",
      align: "center"
    }
  ];

  const data7_1_28 = [
    {
      key: "1",
      c1: "งานวิจัย",
      c2: "จำนวน MOU กับเครือข่ายวิจัย",
      c3: "2",
      c4: "3",
      c5: "1",
      c6: "1",
      c7: "7"
    },
    {
      key: "2",
      c1: "",
      c2: "จำนวนโครงการวิจัยที่สถาบันฯ เป็นผู้ร่วมดำเนินการกับเครือข่ายวิจัย",
      c3: "17",
      c4: "26",
      c5: "31",
      c6: "23",
      c7: "11"
    },
    {
      key: "3",
      c1: "",
      c2: "จำนวนผลงานวิจัยที่ทำร่วมกับหน่วยงานต่างประเทศ",
      c3: "47",
      c4: "50",
      c5: "45",
      c6: "51",
      c7: "74"
    },
    {
      key: "4",
      c1: "",
      c2: "จำนวนผลงานวิจัยที่ทำร่วมกับหน่วยงานภายในประเทศ",
      c3: "19",
      c4: "22",
      c5: "27",
      c6: "30",
      c7: "112"
    },
    {
      key: "5",
      c1: "",
      c2: "การรับอาสาสมัครเข้าร่วมโครงการ (%Entry criteria met)",
      c3: "100",
      c4: "100",
      c5: "100",
      c6: "100",
      c7: "100"
    },
    {
      key: "6",
      c1: "",
      c2: "การคงอยู่ของอาสาสมัครโครงการวิจัย (%Retention rate)",
      c3: "100",
      c4: "100",
      c5: "100",
      c6: "100",
      c7: "100"
    },
    {
      key: "7",
      c1: "",
      c2: "การจัดการสิ่งส่งตรวจทางคลินิก (Certited) :คน เครื่องมือ",
      c3: "Cert.",
      c4: "Cert.",
      c5: "Cert.",
      c6: "Cert.",
      c7: "Cert."
    },
    {
      key: "8",
      c1: "หลักสูตรการวิจัยวิทยาศาสตร์สุขภาพ",
      c2: "จำนวน MOU กับเครือข่ายการศึกษา",
      c3: "0",
      c4: "0",
      c5: "1",
      c6: "1",
      c7: "5"
    },
    {
      key: "9",
      c1: "",
      c2: "จำนวนเครือข่ายการศึกษาที่ให้นักศึกษาไปฝึกประสบการณ์",
      c3: "N/A",
      c4: "0",
      c5: "2",
      c6: "3",
      c7: "5"
    },
    {
      key: "10",
      c1: "",
      c2:
        "ผลการประเมินกระบวนวิชาที่มีผู้เชี่ยวชาญ/อาจารย์พิเศษ ที่หลักสูตรเชิญมาสอน",
      c3: "N/A",
      c4: "4.67",
      c5: "4.33",
      c6: "4.65",
      c7: "N/A"
    },
    {
      key: "11",
      c1: "",
      c2: "ผลการประเมินกระบวนวิชาที่ลงทะเบียนเรียนกับคณะอื่น",
      c3: "N/A",
      c4: "N/A",
      c5: "5",
      c6: "N/A",
      c7: "N/A ไม่มีการเรียนที่คณะอื่น"
    },
    {
      key: "12",
      c1: "บริการวิชาการ",
      c2: "จำนวน MOU กับเครือข่ายบริการวิชาการ",
      c3: "2",
      c4: "1",
      c5: "3",
      c6: "1",
      c7: "2"
    },
    {
      key: "13",
      c1: "",
      c2: "จำนวนตัวอย่างที่เครือข่ายฯ ส่งให้สถาบันฯ ดำเนินการ",
      c3: "10",
      c4: "15",
      c5: "38",
      c6: "45",
      c7: "79"
    },
    {
      key: "14",
      c1: "",
      c2: "จำนวนโครงการบริการวิชาการที่ทำร่วมกับเครือข่ายฯ",
      c3: "1",
      c4: "2",
      c5: "3",
      c6: "1",
      c7: "39"
    }
  ];

  const dataEx7_1_28 = [
    {
      c1: "งานวิจัย",
      c2: "จำนวน MOU กับเครือข่ายวิจัย",
      c3: "2",
      c4: "3",
      c5: "1",
      c6: "1",
      c7: "7"
    },
    {
      c1: "",
      c2: "จำนวนโครงการวิจัยที่สถาบันฯ เป็นผู้ร่วมดำเนินการกับเครือข่ายวิจัย",
      c3: "17",
      c4: "26",
      c5: "31",
      c6: "23",
      c7: "11"
    },
    {
      c1: "",
      c2: "จำนวนผลงานวิจัยที่ทำร่วมกับหน่วยงานต่างประเทศ",
      c3: "47",
      c4: "50",
      c5: "45",
      c6: "51",
      c7: "74"
    },
    {
      c1: "",
      c2: "จำนวนผลงานวิจัยที่ทำร่วมกับหน่วยงานภายในประเทศ",
      c3: "19",
      c4: "22",
      c5: "27",
      c6: "30",
      c7: "112"
    },
    {
      c1: "",
      c2: "การรับอาสาสมัครเข้าร่วมโครงการ (%Entry criteria met)",
      c3: "100",
      c4: "100",
      c5: "100",
      c6: "100",
      c7: "100"
    },
    {
      c1: "",
      c2: "การคงอยู่ของอาสาสมัครโครงการวิจัย (%Retention rate)",
      c3: "100",
      c4: "100",
      c5: "100",
      c6: "100",
      c7: "100"
    },
    {
      c1: "",
      c2: "การจัดการสิ่งส่งตรวจทางคลินิก (Certited) :คน เครื่องมือ",
      c3: "Cert.",
      c4: "Cert.",
      c5: "Cert.",
      c6: "Cert.",
      c7: "Cert."
    },
    {
      c1: "หลักสูตรการวิจัยวิทยาศาสตร์สุขภาพ",
      c2: "จำนวน MOU กับเครือข่ายการศึกษา",
      c3: "0",
      c4: "0",
      c5: "1",
      c6: "1",
      c7: "5"
    },
    {
      c1: "",
      c2: "จำนวนเครือข่ายการศึกษาที่ให้นักศึกษาไปฝึกประสบการณ์",
      c3: "N/A",
      c4: "0",
      c5: "2",
      c6: "3",
      c7: "5"
    },
    {
      c1: "",
      c2:
        "ผลการประเมินกระบวนวิชาที่มีผู้เชี่ยวชาญ/อาจารย์พิเศษ ที่หลักสูตรเชิญมาสอน",
      c3: "N/A",
      c4: "4.67",
      c5: "4.33",
      c6: "4.65",
      c7: "N/A"
    },
    {
      c1: "",
      c2: "ผลการประเมินกระบวนวิชาที่ลงทะเบียนเรียนกับคณะอื่น",
      c3: "N/A",
      c4: "N/A",
      c5: "5",
      c6: "N/A",
      c7: "N/A ไม่มีการเรียนที่คณะอื่น"
    },
    {
      c1: "บริการวิชาการ",
      c2: "จำนวน MOU กับเครือข่ายบริการวิชาการ",
      c3: "2",
      c4: "1",
      c5: "3",
      c6: "1",
      c7: "2"
    },
    {
      c1: "",
      c2: "จำนวนตัวอย่างที่เครือข่ายฯ ส่งให้สถาบันฯ ดำเนินการ",
      c3: "10",
      c4: "15",
      c5: "38",
      c6: "45",
      c7: "79"
    },
    {
      c1: "",
      c2: "จำนวนโครงการบริการวิชาการที่ทำร่วมกับเครือข่ายฯ",
      c3: "1",
      c4: "2",
      c5: "3",
      c6: "1",
      c7: "39"
    }
  ];

  const bExcelClick = xorder => {
    // console.log("Excel button clicked for order:", xorder);
    let xdata = [],
      xtabtitle = "report",
      header = [];

    if (xorder === "7_1_7") {
      xtabtitle = "7.1-7 ผลการประเมินคุณภาพหลักสูตร";

      header.push(
        "ร้อยละของตัวชี้วัดที่ผ่านเกณฑ์ ประเมินคุณภาพหลักสูตร",
        "2565",
        "2566",
        "2567"
      );
    } else if (xorder === "7_1_13") {
      xtabtitle = "7.1-13 จำนวน BEEN research proposal ที่ยื่นขอทุนวิจัย";
    } else if (xorder === "7_1_14") {
      xtabtitle = "7.1-14 จำนวน Inter research proposal ที่ยื่นขอทุนวิจัย";

      header.push("", "64", "65", "66", "67", "68");
    } else if (xorder === "7_1_15") {
      xtabtitle = "7.1-15 จำนวนโครงการวิจัยใหม่ จำแนกตามทิศทางการวิจัย";

      header.push("ปีงบประมาณ", "BEEN", "HIV", "Other", "รวม");
    } else if (xorder === "7_1_16") {
      xtabtitle = "7.1-16 ร้อยละโครงการวิจัยใหม่ จำแนกตามทิศทางการวิจัย";

      header.push("ปีงบประมาณ", "BEEN", "HIV", "Other", "รวม");
    } else if (xorder === "7_1_19") {
      xtabtitle = "7.1-19 อัตราส่วนเงินทุนวิจัยต่องบประมาณแผ่นดิน (เท่า)";

      header.push("", "68");
    } else if (xorder === "7_1_21") {
      xtabtitle =
        "7.1-21 อัตราส่วนผลงานวิจัยตีพิมพ์ต่องบประมาณแผ่นดิน (เรื่อง/ล้านบาท)";
      header.push("", "2568");
    } else if (xorder === "7_1_27") {
      xtabtitle =
        "7.1-27 ผลลัพธ์ด้านความปลอดภัยและการเตรียมความพร้อมต่อภาวะฉุกเฉิน";
      header.push("", "2564", "2565", "2566", "2567", "2568");
    } else if (xorder === "7_1_28") {
      xtabtitle = "7.1-28 ผลลัพธ์ด้านการจัดการเครือข่ายอุปทาน";
      header.push(
        "ผลิตภัณฑ์",
        "ผลลัพธ์",
        "2564",
        "2565",
        "2566",
        "2567",
        "2568"
      );
    }

    xdata.push([xtabtitle]);

    xdata.push([""]);
    xdata.push(header);

    if (xorder === "7_1_7") {
      for (var row in dataEx7_1_7) {
        const xx = [];

        for (var col in dataEx7_1_7[row]) {
          xx.push(dataEx7_1_7[row][col]);
        }

        xdata.push(xx);
      }

      xdata.push([""]);
      xdata.push(["(ปี 68 จะมีผลการประเมินใน เดือน ก.ย. 69)"]);
    } else if (xorder === "7_1_13") {
      xdata.splice(2, 1);

      for (var row in dataEx7_1_13) {
        const xx = [];
        for (var col in dataEx7_1_13[row]) {
          xx.push(dataEx7_1_13[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_1_14") {
      for (var row in dataEx7_1_14) {
        const xx = [];
        for (var col in dataEx7_1_14[row]) {
          xx.push(dataEx7_1_14[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_1_15") {
      for (var row in data7_1_15) {
        const xx = [];
        for (var col in data7_1_15[row]) {
          xx.push(data7_1_15[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_1_16") {
      for (var row in data7_1_16) {
        const xx = [];
        for (var col in data7_1_16[row]) {
          xx.push(data7_1_16[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_1_19") {
      for (var row in dataEx7_1_19) {
        const xx = [];
        for (var col in dataEx7_1_19[row]) {
          xx.push(dataEx7_1_19[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_1_21") {
      for (var row in dataEx7_1_21) {
        const xx = [];
        for (var col in dataEx7_1_21[row]) {
          xx.push(dataEx7_1_21[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_1_27") {
      for (var row in dataEx7_1_27) {
        const xx = [];
        for (var col in dataEx7_1_27[row]) {
          xx.push(dataEx7_1_27[row][col]);
        }
        xdata.push(xx);
      }
    } else if (xorder === "7_1_28") {
      for (var row in dataEx7_1_28) {
        const xx = [];
        for (var col in dataEx7_1_28[row]) {
          xx.push(dataEx7_1_28[row][col]);
        }
        xdata.push(xx);
      }
    }

    var wb = xlsx.utils.book_new(),
      ws = xlsx.utils.json_to_sheet(xdata, { skipHeader: true });

    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    xlsx.writeFile(wb, xtabtitle + ".xlsx");
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านผลิตภัณฑ์และกระบวนการ
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-1 จำนวนผลงานวิจัยที่ถูกนำไปใช้ประโยชน์"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/file_7_1_1_จำนวนผลงานวิจัยที่ถูกนำไปใช้ประโยชน์.xlsx",
                    "_blank"
                  )}
              >
                จำนวนผลงานวิจัยที่ถูกนำไปใช้ประโยชน์
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-2 จำนวนการอ้างอิงผลงานวิจัย"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/file_7_1_2_จำนวนการอ้างอิงผลงานวิจัย.xlsx",
                    "_blank"
                  )}
              >
                จำนวนการอ้างอิงผลงานวิจัย
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-3 จำนวนการอ้างอิงผลงานวิจัยต่อบทความ (Citation per Publication)"
          >
            {/* <Barchart dataBar={dataBar7_1_3} order={"bar7_1_3"} /> */}

            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/file_7_1_3_จำนวนการอ้างอิงผลงานวิจัยต่อบทความCitations_p.xlsx",
                    "_blank"
                  )}
              >
                จำนวนการอ้างอิงผลงานวิจัยต่อบทความ (Citation per Publication)
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-4 ร้อยละผลงงานวิจัยที่ถูกเผยแพร่ในวารสารชั้นนำ Top 10% ของโลก"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/file_7_1_4_ร้อยละผลงานวิจัยที่ถูกเผยแพร่ในวารสาร.xlsx",
                    "_blank"
                  )}
              >
                ร้อยละผลงงานวิจัยที่ถูกเผยแพร่ในวารสารชั้นนำ Top 10% ของโลก
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-5 ร้อยละของผลงานวิจัยที่ถูกเผยแพร่ใน SCOPUS Q1"
          >
            {/* <Barchart dataBar={dataBar7_1_5} order={"bar7_1_5"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div> */}

            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/file_7_1_5_ร้อยละของผลงานวิจัยที่ถูกเผยแพร่ใน_SCOPUS_Q1.xlsx",
                    "_blank"
                  )}
              >
                ร้อยละของผลงานวิจัยที่ถูกเผยแพร่ใน SCOPUS Q1
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-6 Thai CTU SIte performance(%)"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL + "dashboard4/7_1/ACTG_CRS_31784_ASPE_Jul2025.pdf",
                    "_blank"
                  )}
              >
                Thai CTU SIte performance(%)
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 4 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-7 ผลการประเมินคุณภาพหลักสูตร"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button ghost type="success" onClick={() => bExcelClick("7_1_7")}>
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_7}
              dataSource={data7_1_7}
              pagination={false}
              size="small"
              bordered
            />
            <div
              style={{
                textAlign: "center",
                fontSize: 16,
                fontWeight: "bold",
                marginTop: 25
              }}
            >
              (ปี 68 จะมีผลการประเมินใน เดือน ก.ย. 69)
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-8 ผลการประเมินคุณภาพการจัดการเรียนการสอน"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/แบบประเมินความพึงพอใจ_ไม่พึงพอใจSHSR.docx",
                    "_blank"
                  )}
              >
                ผลการประเมินคุณภาพการจัดการเรียนการสอน
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-9 ร้อยละของ นศ. ที่มีผลงานเผยแพร่ใน SCOPUS Q1(%)"
          >
            {/* <Barchart dataBar={dataBar7_1_9} order={"bar7_1_9"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div> */}

            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/file_7_1_9_ร้อยละของ_นศ_ที่มีผลงานเผยแพร่ใน_SCOPUS_Q1_percent.xlsx",
                    "_blank"
                  )}
              >
                ร้อยละของ นศ. ที่มีผลงานเผยแพร่ใน SCOPUS Q1(%)
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-10 จำนวนรางวัลด้านการวิจัยของนักศึกษา"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                color: "#9aa0a6"
              }}
            >
              <div style={{ fontSize: 42 }}>📊</div>
              <div style={{ fontSize: 16, marginTop: 8 }}>ยังไม่มีข้อมูล</div>
              <div style={{ fontSize: 16, marginTop: 4 }}>
                ไม่มีนศ.ได้รางวัลในปี 2568
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-11 คะแนนประเมินคุณภาพการให้บริการของสถาบัน"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Space size="large">
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiMGI5ZGVkMjMtM2EwNC00OTVkLTg0ZmItYTVkOTVmOTY5NGM2IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                >
                  Clinic
                </Button>

                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  ghost
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiN2NiOTBkNjItNmU5NS00MjdkLWE0MzItYjhmMTI2MDUyZjc3IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                >
                  Nutri
                </Button>
              </Space>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-12 ร้อยละของห้องปฏิบัติที่บริการทดสอบ ได้รับการรับรองมาตรฐานสากล"
          >
            <div
              style={{
                height: 220,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                color: "#9aa0a6"
              }}
            >
              <div style={{ fontSize: 42 }}>📊</div>
              <div style={{ fontSize: 16, marginTop: 8 }}>ยังไม่มีข้อมูล</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                ไม่มีข้อมูลสำหรับแสดงในขณะนี้
              </div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                (รอข้อมูลที่จะกรอกเพิ่ม)
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 7 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-13 จำนวน BEEN research proposal ที่ยื่นขอทุนวิจัย"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_13")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_13}
              dataSource={data7_1_13}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-14 จำนวน Inter research proposal ที่ยื่นขอทุนวิจัย"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_14")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_14}
              dataSource={data7_1_14}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 8 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle4,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-15 จำนวนโครงการวิจัยใหม่ จำแนกตามทิศทางการวิจัย"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_15}
              order={"stack7_1_15"}
            />
            <br />

            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_15")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_15}
              dataSource={data7_1_15}
              pagination={false}
              size="small"
              bordered
            />

            <br />
            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ (1 ต.ค. - 30 ก.ย.)
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle4,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-16 ร้อยละโครงการวิจัยใหม่ จำแนกตามทิศทางการวิจัย"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_16}
              order={"stack7_1_16"}
            />
            <br />

            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_16")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_16}
              dataSource={data7_1_16}
              pagination={false}
              size="small"
              bordered
            />

            <br />
            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ (1 ต.ค. - 30 ก.ย.)
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 9 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-17 จำนวนโครงการวิจัยใหม่ จำแนกตามแหล่งทุน"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_17}
              order={"stack7_1_17"}
            />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ (1 ต.ค. - 30 ก.ย.)
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-18 ร้อยละโครงการวิจัยใหม่ จำแนกตามแหล่งทุน"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_18}
              order={"stack7_1_18"}
            />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ (1 ต.ค. - 30 ก.ย.)
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 10 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-19 อัตราส่วนเงินทุนวิจัยต่องบประมาณแผ่นดิน (เท่า)"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_19")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_19}
              dataSource={data7_1_19}
              pagination={false}
              size="small"
              bordered
            />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-20 จำนวนผลงานวิจัยที่ถูกเผยแพร่ใน SCOPUS"
          >
            <Barchart dataBar={dataBar7_1_20} order={"bar7_1_20"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 11 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-21 อัตราส่วนผลงานวิจัยตีพิมพ์ต่องบประมาณแผ่นดิน (เรื่อง/ล้านบาท)"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_21")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_21}
              dataSource={data7_1_21}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-22 ผลประเมินการจัดการข้อมูลวิจัย"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL + "dashboard4/7_1/ACTG_CRS_31784_ASPE_Jul2025.pdf",
                    "_blank"
                  )}
              >
                ผลประเมินการจัดการข้อมูลวิจัย
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 12 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-23 ผลประเมินการติดตามการดำเนินการวิจัยทางคลินิก"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL + "dashboard4/7_1/ACTG_CRS_31784_ASPE_Jul2025.pdf",
                    "_blank"
                  )}
              >
                ผลประเมินการติดตามการดำเนินการวิจัยทางคลินิก
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-25 ประสิทธิผลและประสิทธิภาพของกระบวนการจัดการศึกษา"
          >
            <div
              style={{
                height: 60,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(xURL + "dashboard4/7_1/pic_7_1_25.png", "_blank")}
              >
                ประสิทธิผลและประสิทธิภาพของกระบวนการจัดการศึกษา
              </Button>
            </div>

            <a
              href={xURL + "dashboard4/7_1/file_7_1_25.docx"}
              download="file_7_1_25.docx"
            >
              <Button
                size="small"
                style={{
                  borderRadius: 10,
                  height: 30,
                  padding: "0 28px"
                }}
              >
                ดาวน์โหลดไฟล์
              </Button>
            </a>
          </Card>
        </Col>
      </Row>

      {/* Row 13 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle3,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-27 ผลลัพธ์ด้านความปลอดภัยและการเตรียมความพร้อมต่อภาวะฉุกเฉิน"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_27")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_27}
              dataSource={data7_1_27}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle3,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="7.1-28 ผลลัพธ์ด้านการจัดการเครือข่ายอุปทาน"
          >
            {/* <div
              style={{
                height: 600,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_1/pic_7_1_28_ผลลัพธ์ด้านการจัดการเครือข่ายอุปทาน.png",
                    "_blank"
                  )}
              >
                ผลลัพธ์ด้านการจัดการเครือข่ายอุปทาน
              </Button>
            </div>

            <a
              href={
                xURL +
                "dashboard4/7_1/file_7_1_28_ผลลัพธ์ด้านการจัดการเครือข่ายอุปทาน.docx"
              }
              download="file_7_1_28_ผลลัพธ์ด้านการจัดการเครือข่ายอุปทาน.docx"
            >
              <Button
                size="small"
                style={{
                  borderRadius: 10,
                  height: 30,
                  padding: "0 28px"
                }}
              >
                ดาวน์โหลดไฟล์
              </Button>
            </a> */}

            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_1_28")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_1_28}
              dataSource={data7_1_28}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_1;
